import React from 'react';
import { eventsStore, poiStore, gmapStore, refsStore } from '../managers/globalState';
import '../../www/assets/css/side_menu.css';
import CloseButton from './close_button';
import SpacecraftSVG from '../../www/assets/images/spacecraft.svg';
import LayerGroupSolidSVG from '../../www/assets/images/layer_group_solid.svg';
import ar from '../languages/ar';

class SideMenu extends React.PureComponent {
	_isMounted = false;

	constructor(props) {
		super(props);

		this.state = {
			open: false,
			showEvent: false,
			showPoI: false,
			showGmap: false
		};

		this._toggle = this._toggle.bind(this);
		this._openOverlay = this._openOverlay.bind(this);
		this._handleSelection = this._handleSelection.bind(this);
	}

	componentDidMount() {
		this._isMounted = true;
		this.eventsUnsubscribe = eventsStore.subscribeTo('showOnGlobe', this.toggleEvent.bind(this));
		this.poiUnsubscribe = poiStore.subscribeTo('showOnGlobePoI', this.togglePoI.bind(this));
		this.gmapUnsubscribe = gmapStore.subscribeTo('showOnGlobeGmap', this.toggleGmap.bind(this));
	}

	componentWillUnmount() {
		this._isMounted = false;
		if (typeof this.eventsUnsubscribe === 'function') {
			this.eventsUnsubscribe();
		}
	}

	/**
	 * Todo: We shouldnt directly mutate the local state.
	 * The DateRange component demos how to forceUpdate on global state change in a class component.
	 * Better still, make a functional component - it's much simpler then. - #3191
	 */
	toggleEvent() {
		let { showEvent } = this.state;

		if (eventsStore && eventsStore.state) {
			showEvent = eventsStore.state.showOnGlobe;
		}
		if (this._isMounted) { this.setState({ showEvent }); }
	}

	togglePoI() {
		let { showPoI } = this.state;

		if (poiStore && poiStore.state) {
			showPoI = poiStore.state.showOnGlobePoI;
		}
		if (this._isMounted) { this.setState({ showPoI }); }
	}

	toggleGmap() {
		let { showGmap } = this.state;

		if (gmapStore && gmapStore.state) {
			showGmap = gmapStore.state.showOnGlobeGmap;
		}
		if (this._isMounted) { this.setState({ showGmap }); }
	}

	_toggle() {
		window.scroll(0, 0);
		this.setState({ open: !this.state.open });
	}

	_openOverlay() {
		this.props.overlay.current.open();
		this._toggle();
	}

	_handleSelection(event) {
		event.stopPropagation();
		this.props.handler(event);
		this._toggle();
	}

	_renderPanel() {
		const {
			showMission, selected, list
		} = this.props;

    const { get } = refsStore.stateSnapshot;
		const { missionList, vitalList } = get('content');

		// Filter out past missions from side menu on mobile
		const filteredList = showMission ?
			missionList.filter(mission => mission.categories?.includes('operating') || mission.categories?.includes('planned')) :
			vitalList;

		return (
			<div className='side-overlay scrollable'>
				<div className='side-content'>
					<header className='filter-bar'>
						{this._renderIcon()}
						<h2
							className='grid-title'
							id={showMission ? 'missions-title' : 'vital-signs-title'}
						>
							{ showMission ? ar.missions : ar.vital_signs }
						</h2>
						<CloseButton responsive onClick={this._toggle} />
					</header>
					<ul className='list-unstyled item-list'>
						{
							filteredList.map((item, index) => (
								<li
									key={index}
									className={'nav-item' + ([item.external_id, item.value].includes(selected) ? ' selected' : '')}
									data-value={showMission ? item.external_id : item.value}
									onClick={this._handleSelection}
								>
									{item.title}
								</li>
							))
						}
					</ul>
				</div>
			</div>
		);
	}

	_renderIcon() {
		const { showMission } = this.props;
		return (
			<div className='side-icon'>
				{
					showMission
						? <SpacecraftSVG />
						: <LayerGroupSolidSVG />
				}
			</div>
		);
	}

	_renderButton() {
		const { showEvent,showPoI, showGmap } = this.state;

		if (showEvent || showPoI || showGmap) { return null; }

		return (
			<div className='side-btn' onClick={this._toggle}>
				{this._renderIcon()}
			</div>
		);
	}
	
	render() {
		const { open } = this.state;
		return open ? this._renderPanel() : this._renderButton();
	}
}

export default SideMenu;
